import { useState, useEffect, useMemo } from 'react';
import fhirpath from 'fhirpath';

export const useFhirResources = (fhirClient, fhirPathResources) => {
	const [fhirResources, setFhirResources] = useState([]);
	const [isFhirResourcesLoaded, setIsFhirResourcesLoaded] = useState(false);

	useEffect(() => {
		(async () => {
			if (fhirClient?.client) {
				try {
					let data = [];

					if (fhirClient.client.hasOwnProperty('user')) {
						let practitionerData = await fhirClient.client.user.read();
						data.push(practitionerData);
					}

					if (fhirClient.client.hasOwnProperty('patient')) {
						let patientData = await fhirClient.client.patient.read();
						data.push(patientData);
					}

					for (let idx in fhirPathResources) {
						try {
							let resource = fhirPathResources[idx];
							let resourceData = await fhirClient.client.request(resource);

							data.push(resourceData);
						} catch {
							console.error(`Unable to load fhirPath resource ${fhirPathResources[idx]}`);
						}
					}

					setFhirResources(data);
					setIsFhirResourcesLoaded(true);
				} catch {
					console.log('There was an error retrieving external data.');
				}
			}
		})();
	}, [fhirClient?.client]);

	return { fhirResources, isFhirResourcesLoaded };
}

export const useFhirResolver = (resources, dependencies) => {
	const fhirResources = useMemo(() =>
		typeof (resources) === 'function' ? resources() : resources,
		dependencies);

	const fhirResolveString = (template) => {
		let rendered = template || '';
		const matches = rendered.match(/\${([^}]+)}/ig);
		for (let idx in matches) {
			const key = matches[idx].replace('${', '').replace('}', '');
			rendered = rendered.replace(matches[idx], fhirResolve(key, true) || '');
		}
		return rendered;
	}

	const fhirResolve = (path, selectFirstArrayItem = false) => {
		let key = path.split('.')[0];
		let resource = fhirResources?.filter(p => p.resourceType === key || !p.hasOwnProperty('resourceType'));

		if (!resource || resource?.length === 0) return null;

		let data = fhirpath.evaluate(resource[0], path);

		if (data.length === 1) {
			return data[0];
		}
		else if (data.length === 0) {
			return null;
		}
		else if (selectFirstArrayItem) {
			return data[0]; // TODO: remove this so it doesn't auto select first item
        }
		return data;
	}

	return { fhirResolve, fhirResolveString };
}
